'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
    init: function (paymentMethodResponse, container, selectedPaymentMethod, config, paymentDetails) {
        const configuration = {
            locale: config.locale,
            amount: {
                currency: config.priceCurrency,
                value: config.priceAmount
            },
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        checkout
            .create('amazonpay', {
                checkoutMode: 'ProcessOrder',
                addressDetails: {
                    name: paymentDetails.name,
                    addressLine1: paymentDetails.adressLine1,
                    city: paymentDetails.city,
                    postalCode: paymentDetails.postalCode,
                    countryCode: paymentDetails.countryCode,
                    phoneNumber: paymentDetails.phoneNumber
                },

                environment: config.environment,
                currency: config.priceCurrency,
                returnUrl: Urls.checkoutAmazonPayment
            })
            .mount(container);
    },

    initOrder: function (paymentMethodResponse, container, selectedPaymentMethod, config, amazonCheckoutSessionId) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        checkout
            .create('amazonpay', {
                environment: config.environment,
                amount: {
                    currency: config.priceCurrency,
                    value: config.priceAmount
                },
                amazonCheckoutSessionId: amazonCheckoutSessionId,
                returnUrl: Urls.checkoutAmazonPayment,
                showChangePaymentDetailsButton: true // Optional
            })
            .mount(container);
    },

    initPayment: function (
        paymentMethodResponse,
        container,
        selectedPaymentMethod,
        config,
        onSubmitCallback,
        amazonCheckoutSessionId,
        onAdditionalDetailsCallback
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        const amazonPayOrder = checkout
            .create('amazonpay', {
                environment: config.environment,
                showOrderButton: false,
                onSubmit: onSubmitCallback,
                onAdditionalDetails: onAdditionalDetailsCallback,
                amazonCheckoutSessionId: amazonCheckoutSessionId
            })
            .mount(container);

        amazonPayOrder.submit();
    },

    getPaymentDetails: function (
        paymentMethodResponse,
        selectedPaymentMethod,
        config,
        amazonCheckoutSessionId,
        detailsCallBack
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        const amazonPayComponent = checkout.create('amazonpay', {
            environment: config.environment,
            showOrderButton: false,
            amazonCheckoutSessionId: amazonCheckoutSessionId
        });
        amazonPayComponent.getShopperDetails().then((details) => {
            detailsCallBack(details);
        });
    },
    getAmazonSessionID: function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get('amazonCheckoutSessionId');
    }
};

module.exports = exportFunctions;
